import React from "react"
import LoadMoreButton from "./LoadMoreButton"
import sequenceStore from "../stores/sequenceStore"
import Sequence from "../models/sequence"
import { observer, Provider } from "mobx-react"
import SequenceCard from "./SequenceCard"
import Grid from '@mui/material/Grid2';
import { styled } from "@mui/material/styles"

const stores = {
  sequenceStore,
}

const SequencesContainer = styled('div')`
  padding: 0 0.75rem;
`

@observer
export default class Sequences extends React.Component {
  constructor(props) {
    super(props)
    sequenceStore.sequences = props.sequences.map(
      (sequence) => new Sequence(sequence)
    )
  }

  renderSequnceRow(sequences) {
    const sequenceUUids = sequences.map( sequence => sequence.uuid)
    return (
      <div className="row" key={sequenceUUids} >
        {sequences.map((sequence) => {
          return <SequenceCard sequence={sequence} key={sequence.uuid} />
        })}
      </div>
    )
  }

  renderSequenceCards() {
    const sequences = sequenceStore.sequences
    return sequences.map((sequence) => {
      return (
        <Grid size={{xs: 6, sm: 3, md: 3, lg:3}} key={sequence.uuid}>
          <SequenceCard sequence={sequence} />
        </Grid>
      )
    })
  }

  render(){
    const { pagyMetadata } = this.props

    return (
      <Provider {...stores}>
        <SequencesContainer>
          <Grid container spacing={2}>
            {this.renderSequenceCards()}
          </Grid>
          <LoadMoreButton pagyMetadata={pagyMetadata} />
        </SequencesContainer>
      </Provider>
    )
  }

}
